var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 531.91 137.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #b3b3b3;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.13,9.88h50.98l-60.56,118h-50.98L205.13,9.88Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_1",
    "data-name": "Laag 1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laag_1-2",
    "data-name": "Laag 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,137.77L70.71,0h461.2l-70.71,137.77"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M79.28,9.88h125.77l-13.01,25.35H117.36l-10.58,20.61,75.39-.88-12.23,23.82-75.39,.88-24.75,48.21H18.71L79.28,9.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.29,9.88h50.87l-45.65,88.94h79.39l-14.91,29.06H195.73L256.29,9.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.75,56.21h66.48l-13.01,25.35h-66.48l13.01-25.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.4,9.88h154.63l-14.95,29.14h-51.88l-45.61,88.86h-50.87l45.61-88.86h-51.88l14.95-29.14Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "78.81 4 143.17 133.77 160.35 133.77 95.99 4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "112.33 4 176.69 133.77 193.87 133.77 129.51 4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "144.57 4 208.92 133.77 226.1 133.77 161.74 4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "178.09 4 242.44 133.77 259.62 133.77 195.26 4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "210.27 4 274.62 133.77 291.8 133.77 227.44 4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "243.79 4 308.14 133.77 325.32 133.77 260.96 4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.263515ce9c42fe848a25819a7bcb6765.svg";
export { ForwardRef as ReactComponent };